import type { Locale } from "@/shared/i18n/translations";

const en = {
  schedule: "Schedule a conversation",
  changeDate: "Change date",
  scheduled:
    "Conversation scheduled. Its source, review, and notes stay linked here.",
  open: "Open conversation",
  backConversations: "Back to conversations",
  backSchedule: "Back to scheduler",
  backNotes: "Back to notes",
  manualNote: "Write a manual note",
  sourceNote: "Use an existing conversation",
  sourceNoteBody:
    "For an AI-assisted note, choose a conversation. Add a transcript or authorized audio if it has no source yet.",
  calendar: "Open scheduler",
  loadFailed: "Could not load appointments.",
  retry: "Try again",
  plan: "Scheduled",
  resume: "Add source or prepare",
};
type Copy = typeof en;
const copy: Record<Locale, Copy> = {
  en,
  uk: {
    schedule: "Запланувати розмову",
    changeDate: "Змінити дату",
    scheduled:
      "Розмову заплановано. Її джерело, огляд і нотатки залишаються пов’язаними.",
    open: "Відкрити розмову",
    backConversations: "До розмов",
    backSchedule: "До планувальника",
    backNotes: "До нотаток",
    manualNote: "Написати нотатку вручну",
    sourceNote: "Використати наявну розмову",
    sourceNoteBody:
      "Для нотатки за допомогою ШІ оберіть розмову. Якщо джерела ще немає, додайте транскрипт або дозволене аудіо.",
    calendar: "Відкрити планувальник",
    loadFailed: "Не вдалося завантажити зустрічі.",
    retry: "Спробувати ще",
    plan: "Заплановано",
    resume: "Додати джерело або підготуватися",
  },
  pl: {
    schedule: "Zaplanuj rozmowę",
    changeDate: "Zmień datę",
    scheduled:
      "Rozmowa zaplanowana. Jej źródło, przegląd i notatki pozostają połączone.",
    open: "Otwórz rozmowę",
    backConversations: "Wróć do rozmów",
    backSchedule: "Wróć do harmonogramu",
    backNotes: "Wróć do notatek",
    manualNote: "Napisz notatkę ręcznie",
    sourceNote: "Użyj istniejącej rozmowy",
    sourceNoteBody:
      "Aby utworzyć notatkę z pomocą AI, wybierz rozmowę. Dodaj transkrypcję lub autoryzowane audio, jeśli nie ma jeszcze źródła.",
    calendar: "Otwórz harmonogram",
    loadFailed: "Nie udało się wczytać spotkań.",
    retry: "Spróbuj ponownie",
    plan: "Zaplanowano",
    resume: "Dodaj źródło lub przygotuj się",
  },
  ro: {
    schedule: "Programează o conversație",
    changeDate: "Schimbă data",
    scheduled:
      "Conversație programată. Sursa, analiza și notițele ei rămân conectate.",
    open: "Deschide conversația",
    backConversations: "Înapoi la conversații",
    backSchedule: "Înapoi la planificator",
    backNotes: "Înapoi la notițe",
    manualNote: "Scrie o notiță manuală",
    sourceNote: "Folosește o conversație existentă",
    sourceNoteBody:
      "Pentru o notiță asistată de AI, alege o conversație. Adaugă o transcriere sau audio autorizat dacă nu are încă o sursă.",
    calendar: "Deschide planificatorul",
    loadFailed: "Programările nu au putut fi încărcate.",
    retry: "Încearcă din nou",
    plan: "Programat",
    resume: "Adaugă sursă sau pregătește",
  },
};
const nextConversation = {
  en: "Schedule next conversation",
  uk: "Запланувати наступну розмову",
  pl: "Zaplanuj następną rozmowę",
  ro: "Programează următoarea conversație",
};
export const toolFlowCopy = (locale: Locale) => ({
  ...(copy[locale] ?? en),
  nextConversation: nextConversation[locale] ?? nextConversation.en,
});
